import type { ReactElement } from 'react'

import Button from '@space-core/components/button'
import type Icon from '@space-shell/common/components/icon'

type ActionsMenuItemProps = {
  children: string
  onClickItem: () => void
  icon: ReactElement<typeof Icon>
}

function ActionsMenuItem({ icon, children, onClickItem }: ActionsMenuItemProps) {
  return (
    <li>
      <Button
        variation='tertiary'
        onClick={onClickItem}
        style={{ gap: '0.5rem' }}
        className='_d-flex _w-full _align-items-center _px-5 _py-4 _text-gray-900'>
        {icon}
        {children}
      </Button>
    </li>
  )
}

export default ActionsMenuItem
